import { VialaserLogo } from 'shared/presentation/components/atoms';
import { useTheme } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

import * as S from './styles';

const LOGO_WIDTHS = {
  DESKTOP: 165,
  MOBILE: 100,
};

const Header: React.FC = () => {
  const { theme } = useTheme();
  const isMobile = useMediaQuery('md');

  return (
    <S.Container>
      <div>
        <VialaserLogo
          size={isMobile ? LOGO_WIDTHS.MOBILE : LOGO_WIDTHS.DESKTOP}
          color={theme.palette.text.main}
          colors={{
            via: theme.palette.primary.main,
          }}
        />
      </div>
    </S.Container>
  );
};

export default Header;
